import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { clsx } from 'clsx';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { DescTopTable } from './DescTopTable';
import { MobileTable } from './MobileTable';

interface CurrentSubscriptionPlansProps {
  projectsSubscriptionsIsFetching: boolean;
  infoOnly?: boolean;
}

export const CurrentSubscriptionPlans = ({
  projectsSubscriptionsIsFetching,
  infoOnly,
}: CurrentSubscriptionPlansProps) => {
  const isMdDown = useMediaQuery('(max-width: 767px)');

  const { data: account, isLoading: isLoadingAccount } = useGetAccountsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const isEmpty = !Object.keys(account?.general_plan || {})?.length;

  const generalPlan = account?.general_plan;

  const planRequestLimit =
    generalPlan?.custom_plan_settings?.request_limit || generalPlan?.plan?.request_limit;

  const generalPlanRequestLimit = generalPlan?.request_limit;

  return isEmpty ? (
    <div className="empty-message">
      <LoaderWrapper loader={<Skeleton className="w-full h-16" />} isLoading={isLoadingAccount}>
        <div className="border rounded-sm-5 px-5 md:py-5 py-4">
          <p className="opacity-70 font-semibold text-base text-ebony">No active subscription.</p>
        </div>
      </LoaderWrapper>
    </div>
  ) : (
    <section
      className={clsx(
        'team-list transition',
        projectsSubscriptionsIsFetching && 'animate-pulse blur-sm pointer-events-none',
      )}
    >
      {isMdDown ? (
        <MobileTable
          infoOnly={infoOnly}
          planRequestLimit={planRequestLimit}
          generalPlanRequestLimit={generalPlanRequestLimit}
          generalPlan={generalPlan}
        />
      ) : (
        <DescTopTable
          infoOnly={infoOnly}
          planRequestLimit={planRequestLimit}
          generalPlanRequestLimit={generalPlanRequestLimit}
          generalPlan={generalPlan}
        />
      )}
    </section>
  );
};
